export function createUrlWithUtm(url: string): string {
  if (!url.match(/https?:\/\//)) {
    // If the URL does not start with http:// or https://, prepend it
    url = "https://" + url;
  }
  const urlObject = new URL(url);
  urlObject.searchParams.append("referrer", "takyon");
  urlObject.searchParams.append("utm_source", "takyon");
  urlObject.searchParams.append("utm_medium", "referral");

  return urlObject.toString();
}
